import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'view-design'
import { setToken, getToken, canTurnTo, setTitle } from '@/libs/util'
import config from '@/config'
const { homeName } = config

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const router = new Router({
  routes:store.getters.getRouters,
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/' : '/'
})
const LOGIN_PAGE_NAME = 'login'

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, store.getters.getRouters)) next() // 有权限，可访问
  else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  const token = getToken()
  if (to.query.token) {
    setToken(to.query.token);
    // window.location.reload();
    delete to.query.token
    next({
      path: to.path,
      replace: true
    })
    return
  }
  
  
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName // 跳转到homeName页
    })
  } else {
    if(from.path == '/' || from.path == '/login'){
      store.dispatch('getUserInfo')
    }
      next()
  }
})

router.afterEach((to) => {
  setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

router.onError((error, to, from) => {
  const pattern = /Loading chunk chunk-(.*)+ failed/g
  const staticFilesErr = /Failed to load resource/g
  const isChunkLoadFailed = error.message.match(pattern)
  const isStaticFilesLoadFailed = error.message.match(staticFilesErr)
  localStorage.setItem('route-error',JSON.stringify({
    error,
    to,
    from
  }))
  
  if (isChunkLoadFailed || isStaticFilesLoadFailed) {
    location.reload()
  }
})
export default router
